<template>
  <router-link v-if="to" :to="to" :class="button({ variant: props.variant, size: props.size })">
    <transition name="slide">
      <div v-if="isLoading" class="inline-flex w-[1.5em] overflow-clip">
        <Spinner class="h-[1em] w-[1em]" />
      </div>
    </transition>
    <slot />
  </router-link>
  <button
    v-else
    :class="button({ variant: props.variant, size: props.size, className: props.class })"
    :data-loading="isLoading"
    :disabled="disabled || isLoading"
  >
    <div
      class="class flex items-center gap-2 transition duration-300"
      :class="{ 'translate-x-[0.65rem]': isLoading }"
    >
      <div
        class="absolute h-[1em] w-[1em] transform transition duration-300"
        :class="{
          'translate-x-0 opacity-0': !isLoading,
          'opacity-1 translate-x-[-1.3rem]': isLoading,
        }"
      >
        <Spinner class="h-[1em] w-[1em]" />
      </div>
      <slot />
    </div>
  </button>
</template>

<script lang="ts" setup>
import type { RouteLocationNamedRaw } from 'vue-router';
import { button } from '@carvia/theme/lib/cva/button';
import type { CvaComponentProps } from '@carvia/theme/lib/cva/CvaComponentProps.ts';
import Spinner from '@/components/icons/Spinner.vue';
import type { HTMLAttributes } from 'vue';

type PropsType = CvaComponentProps<typeof button>;

const props = withDefaults(
  defineProps<{
    variant?: PropsType['variant'];
    outline?: boolean;
    to?: RouteLocationNamedRaw;
    isLoading?: boolean;
    size?: PropsType['size'];
    class?: HTMLAttributes['class'];
    disabled?: boolean;
  }>(),
  {
    variant: 'secondary',
    outline: false,
    to: undefined,
    size: 'sm',
  },
);
</script>
